// Domain types for the Admin Attachment Types MSPA.

// The document_type enum, mirrored from the Rails `AttachmentType` model
// (enum document_type: { image: 0, pdf: 1, word: 2 }). The label is what both
// the list table and the form's Document Type dropdown display.
export const DOCUMENT_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "image", label: "Image" },
  { value: "pdf", label: "PDF" },
  { value: "word", label: "Word" },
];

export const documentTypeLabel = (value: string | null | undefined): string =>
  DOCUMENT_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value ?? "";

// A row in the attachment types list table.
export interface AttachmentType {
  id: string;
  name: string;
  documentType: string;
}

// Controlled values for the attachment type create/edit form.
export interface AttachmentTypeFormValues {
  name: string;
  documentType: string;
}

export const emptyAttachmentTypeForm: AttachmentTypeFormValues = {
  name: "",
  documentType: "",
};
